import _ from 'lodash';
import React from 'react';

import Button from 'components/Button';
import DateRangePicker from 'components/DateRangePicker';
import Select from 'components/Select';
import ButtonSwitch from 'components/ButtonSwitch';
import ErrorBlock from 'components/ErrorBlock';
import {UNITS_CHOICES, VIEW_CHOICES, RESOLUTION_OPTIONS} from 'ducks/occupancy';
import {headOption} from 'utils/common';

const selectViewOptions = [
  {label: 'Occupied', value: VIEW_CHOICES.OCCUPIED},
  {label: 'Available', value: VIEW_CHOICES.AVAILABLE}
];

const selectUnitOptions = [
  {label: '%', value: UNITS_CHOICES.PERCENT},
  {label: '123', value: UNITS_CHOICES.NUMBERS}
];

const OverviewSectionHeader = ({
  toggleViewRenderer,
  toggleUnitsRenderer,
  onResolutionChange,
  onPeriodChange,
  error,
  loading,
  startDate,
  endDate,
  resolution,
  exportReport,
  exporting
}) => (
  <React.Fragment>
    {error && <ErrorBlock>{error}</ErrorBlock>}
    <div className="OverviewSection__header colab-centered-v colab-row-space-between">
      <div className="colab-heading">Occupancy Overview</div>
      <Button white onClick={exportReport} isLoading={exporting}>
        Export
      </Button>
    </div>
    <div className="OverviewSection__filters colab-centered-v colab-row-space-between">
      <div className="colab-elements-row">
        <ButtonSwitch
          className="OverviewSection__viewSwitch"
          options={selectViewOptions}
          initialValue={headOption(selectViewOptions, x => x.value)}
          onChange={chosenValue => toggleViewRenderer(chosenValue.value)}
        />
        <DateRangePicker
          className="colab-small-border-radius"
          handleChange={onPeriodChange}
          start={startDate}
          end={endDate}
          disabled={loading}
          selectYearAndMonth={false}
        />
      </div>
      <div className="colab-elements-row">
        <Select
          options={_.values(RESOLUTION_OPTIONS)}
          value={resolution.value}
          clearable={false}
          className="colab-bold"
          onChange={onResolutionChange}
          disabled={loading}
        />
        <ButtonSwitch
          className="OverviewSection__unitsSwitch"
          options={selectUnitOptions}
          initialValue={headOption(selectUnitOptions, x => x.value)}
          onChange={chosenValue => toggleUnitsRenderer(chosenValue.value)}
        />
      </div>
    </div>
  </React.Fragment>
);

export default OverviewSectionHeader;
